import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { STORAGE_KEYS, STORE_FIELDS, WindowRef } from '@experian-digital/affordability-library';
import { CookieService } from '@experian-digital/affordability-library/src/lib/shared/services/lib-cookie.service';
import { ApplicationConfigService } from '@portal-shared/services/config.service';
import { BaseComponent } from '../base/base.component';

@Component({
  selector: 'aff-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CookiePolicyComponent extends BaseComponent implements OnInit {
  constructor(
    private windowRef: WindowRef,
    injector: Injector,
  ) {
    super(injector);
  }

  toggleChecked = false;

  get showPendoCookies(): boolean {
    const { enablePendo, pendoApiKey } = ApplicationConfigService.config;
    return enablePendo === 'true' && !!pendoApiKey && !pendoApiKey.startsWith('#{');
  }

  ngOnInit(): void {
    this.toggleChecked = CookieService.readCookie(localStorage.getItem(STORAGE_KEYS.cookieConsentName));
    this.windowRef.nativeWindow.addEventListener(
      'storage',
      (message): void => this.handleCookieMessage(message),
      false,
    );
    this.store.add(STORE_FIELDS.loading, null);
  }

  updateCookieDecision(): void {
    this.toggleChecked = !this.toggleChecked;
    CookieService.setCookie(localStorage.getItem(STORAGE_KEYS.cookieConsentName), this.toggleChecked);
    localStorage.setItem('sendCookieDecision', this.toggleChecked.toString());
  }

  private handleCookieMessage(message: any): void {
    if (message.key === 'sendCookieDecisionToPolicy' && message.newValue !== null) {
      this.toggleChecked = JSON.parse(message.newValue);
      localStorage.removeItem('sendCookieDecisionToPolicy');
    }
  }
}
